import { render } from "./Stats.vue?vue&type=template&id=0401c72f"
import script from "./Stats.vue?vue&type=script&lang=js"
export * from "./Stats.vue?vue&type=script&lang=js"

import "./Stats.vue?vue&type=style&index=0&id=0401c72f&lang=css"

import exportComponent from "/Users/kovacsistvan/develop/segito-kezek/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__